import React, { Component } from "react";
import Translation from "../translation/translation";
import { Redirect } from "react-router-dom";
import $ from "jquery";
import Context from "../context/context";
import Comm from "../comm/comm";
import moment from "moment";
import PackinglistData from "../controls/packinglistdata";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import SelectAll from "../controls/selectall";
import { saveAs } from "file-saver";

class SalesReport extends Component {
    PackingListsPage;
    PageSize;
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        this.PackingListsPage = 0;
        this.PageSize = 10;
        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;

        var partners = Comm.Partners(sid);
        var all = {
            id: -1,
            name: Translation.Trans("all"),
        };
        partners.splice(0, 0, all);
        var packinglists = this.PackingLists();

        this.state = {
            QueryType: "packinglists",
            ShowResult: false,
            Partners: partners,
            PackingLists: packinglists,
            StartDateAnd: moment().startOf("day"),
            EndDateAnd: moment().endOf("day"),
            StartDateOr: moment().startOf("day"),
            EndDateOr: moment().endOf("day"),
        };

        this.ShowPackingListQuery = this.ShowPackingListQuery.bind(this);
        this.ShowClientsOrArticles = this.ShowClientsOrArticles.bind(this);
        this.ShowClientsAndArticles = this.ShowClientsAndArticles.bind(this);
        this.ChangePartner = this.ChangePartner.bind(this);
        this.PackingListPageChange = this.PackingListPageChange.bind(this);
        this.ChangeStartDateOr = this.ChangeStartDateOr.bind(this);
        this.ChangeEndDateOr = this.ChangeEndDateOr.bind(this);
        this.ChangeStartDateAnd = this.ChangeStartDateAnd.bind(this);
        this.ChangeEndDateAnd = this.ChangeEndDateAnd.bind(this);
        this.FillAndData = this.FillAndData.bind(this);
        this.ChangeIsPartner = this.ChangeIsPartner.bind(this);
        this.ShowPackingList = this.ShowPackingList.bind(this);
        this.PrintElem = this.PrintElem.bind(this);
        this.ShowAndQueryResult = this.ShowAndQueryResult.bind(this);
        this.ShowOrQueryResult = this.ShowOrQueryResult.bind(this);
        this.ShowAndQueryReport = this.ShowAndQueryReport.bind(this);
        this.ShowOrQueryReport = this.ShowOrQueryReport.bind(this);
        this.ShowPackingListReport = this.ShowPackingListReport.bind(this);
        this.Export = this.Export.bind(this);
        this.ShowCodes = this.ShowCodes.bind(this);
    }

    Export(content) {
        var html =
            "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" +
            content +
            "</body></html>";
        var file = new Blob([html]);
        saveAs(file, "export.xls");
    }

    FillAndData(date1, date2) {
        if (date1 === null) date1 = this.state.StartDateAnd;
        if (date2 === null) date2 = this.state.EndDateAnd;
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };
        var info = Comm.SalesPartnersAndGoods(data);
        this.setState({
            StartDateAnd: moment(date1),
            EndDateAnd: moment(date2),
            AndData: info,
        });
    }

    ChangeStartDateAnd(date) {
        var d1 = date;
        var d2 = this.state.EndDateAnd;
        this.FillAndData(d1, d2);
    }

    ChangeEndDateAnd(date) {
        var d1 = this.state.StartDateAnd;
        var d2 = date;
        this.FillAndData(d1, d2);
    }

    ChangeStartDateOr(date) {
        var d1 = date;
        var d2 = this.state.EndDateOr;
        this.FillOrData(d1, d2, null);
    }

    ChangeEndDateOr(date) {
        var d1 = this.state.StartDateOr;
        var d2 = date;
        this.FillOrData(d1, d2, null);
    }

    FillOrData(date1, date2, partner) {
        if (date1 === null) date1 = this.state.StartDateOr;
        if (date2 === null) date2 = this.state.EndDateOr;
        if (partner === null) partner = this.state.IsPartner;
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };

        var info = Comm.SalesPartnersOrGoods(data, partner);
        this.setState({
            StartDateOr: moment(date1),
            EndDateOr: moment(date2),
            IsPartner: partner,
            OrData: info,
            PartnerOrGood: partner,
        });
    }

    ChangeIsPartner(value) {
        this.FillOrData(null, null, value);
    }

    ChangePartner() {
        this.PackingListsPage = 0;

        var packinglists = this.PackingLists();
        this.setState({ PackingLists: packinglists });
    }

    PackingListPageChange(inc) {
        this.PackingListsPage += inc;
        var packinglists = this.PackingLists();
        this.setState({ PackingLists: packinglists });
    }

    PackingLists() {
        var sid = Context.GetContext().Sid;
        var partnerId = $("#ddlPartner").val();
        var data = { session: sid, page: this.PackingListsPage, pagesize: this.PageSize };
        if (partnerId !== "-1") data.partner = partnerId;
        var packingLists = Comm.PackingLists(data);
        return packingLists;
    }

    Save() {}

    ShowPackingListQuery() {
        this.setState({
            QueryType: "packinglists",
            ShowResult: false,
        });
    }

    ShowClientsOrArticles() {
        this.setState({
            QueryType: "clientsorarticles",
            ShowResult: false,
            OrData: {},
        });
        this.FillOrData(null, null, true);
    }

    ShowClientsAndArticles() {
        this.setState({
            QueryType: "clientsandarticles",
            ShowResult: false,
            AndData: {},
        });
        this.FillAndData(null, null);
    }

    ShowCodes(id) {
        var sid = Context.GetContext().Sid;
        let data = {
            session: sid,
            id: id,
            lang: Translation.CurrentLanguage().toLowerCase(),
        };

        let html = Comm.CallServerFunction("report/packing_list_codes", data);
        var mywindow = window.open("", "_blank");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write("</head><body >");
        mywindow.document.write(html.html);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        //this.RotateColumns(mywindow.document);
    }

    ShowPackingList(id) {
        var sid = Context.GetContext().Sid;

        var pl = Comm.PackingList({
            session: sid,
            id: id,
            lang: Translation.CurrentLanguage().toLowerCase(),
        });
        var html = pl != null ? pl.html : "";
        html = html.replace(/fixed/gi, "relative");
        html = html + "<nocache id='" + moment().format() + "'/>";
        this.setState({
            QueryType: "ShowPackingList",
            DisplayedPackingList: id,
            PackingListHtml: html,
            Landscape: pl != null ? pl.landscape : false,
            ExportType: "ShowPackingList",
        });
    }

    ShowPackingListReport() {
        this.setState({ QueryType: "ShowPackingList" });
    }

    ShowAndQueryReport(forExport = false) {
        var date1 = this.state.StartDateAnd;
        var date2 = this.state.EndDateAnd;

        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };
        if (forExport) {
            data.export = 1;
        }
        var partners = [];
        $("input[id^=cbPartner]:checked").each(function (i, e) {
            partners.push(parseInt($(e).attr("permvalue"), 10));
        });
        data.partners =
            this.state.QueryType === "ShowPackingList" && this.state.ExportType && this.state.ExportType.partners
                ? this.state.ExportType.partners
                : JSON.stringify(partners);

        var goods = [];
        $("input[id^=cbGood]:checked").each(function (i, e) {
            goods.push(parseInt($(e).attr("permvalue"), 10));
        });
        data.goods =
            this.state.QueryType === "ShowPackingList" && this.state.ExportType && this.state.ExportType.goods
                ? this.state.ExportType.goods
                : JSON.stringify(goods);
        data.lang = Translation.CurrentLanguage().toLowerCase();

        var pl = Comm.SalesByPartnersAndGoods(data);
        pl = pl + "<nocache id='" + moment().format() + "'/>";

        if (forExport) {
            this.Export(pl);
        } else {
            this.setState({
                QueryType: "ShowPackingList",
                PackingListHtml: pl,
                Landscape: false,
                ExportType: { type: "ShowAndQueryReport", partners: data.partners, goods: data.goods },
            });
        }
    }

    ShowOrQueryReport(forExport = false) {
        var date1 = this.state.StartDateOr;
        var date2 = this.state.EndDateOr;

        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };
        if (forExport) {
            data.export = 1;
        }
        var pl = null;
        if (this.state.PartnerOrGood) {
            var partners = [];
            $("input[id^=cbPartner]:checked").each(function (i, e) {
                partners.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.partners =
                this.state.QueryType === "ShowPackingList" && this.state.ExportType && this.state.ExportType.partners
                    ? this.state.ExportType.partners
                    : JSON.stringify(partners);
            data.lang = Translation.CurrentLanguage().toLowerCase();

            pl = Comm.SalesByPartners(data);
        } else {
            var goods = [];
            $("input[id^=cbGood]:checked").each(function (i, e) {
                goods.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.goods =
                this.state.QueryType === "ShowPackingList" && this.state.ExportType && this.state.ExportType.goods
                    ? this.state.ExportType.goods
                    : JSON.stringify(goods);
            data.lang = Translation.CurrentLanguage().toLowerCase();

            pl = Comm.SalesByGoods(data);
        }
        pl = pl + "<nocache id='" + moment().format() + "'/>";
        if (forExport) {
            this.Export(pl);
        } else {
            this.setState({
                QueryType: "ShowPackingList",
                PackingListHtml: pl,
                Landscape: false,
                ExportType: { type: "ShowOrQueryReport", partners: data.partners, goods: data.goods },
            });
        }
    }

    ShowAndQueryResult(pageInc, first) {
        var data;
        var date1 = this.state.StartDateAnd;
        var date2 = this.state.EndDateAnd;

        var sid = Context.GetContext().Sid;
        data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
            page: 0,
            pagesize: this.PageSize,
        };
        var partners = [];
        $("input[id^=cbPartner]:checked").each(function (i, e) {
            partners.push(parseInt($(e).attr("permvalue"), 10));
        });
        data.partners = JSON.stringify(partners);

        var goods = [];
        $("input[id^=cbGood]:checked").each(function (i, e) {
            goods.push(parseInt($(e).attr("permvalue"), 10));
        });
        data.goods = JSON.stringify(goods);
        data.operation = "and";
        window.open("/salesreportresult/" + JSON.stringify(data));
    }

    ShowOrQueryResult(pageInc, first) {
        var data;
        var date1 = this.state.StartDateOr;
        var date2 = this.state.EndDateOr;

        var sid = Context.GetContext().Sid;
        data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
            page: 0,
            pagesize: this.PageSize,
        };

        if (this.state.PartnerOrGood) {
            var partners = [];
            $("input[id^=cbPartner]:checked").each(function (i, e) {
                partners.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.partners = JSON.stringify(partners);
        } else {
            var goods = [];
            $("input[id^=cbGood]:checked").each(function (i, e) {
                goods.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.goods = JSON.stringify(goods);
        }

        data.partnerorgood = this.state.PartnerOrGood;
        data.operation = "or";
        window.open("/salesreportresult/" + JSON.stringify(data));
    }

    RotateColumns(document) {
        var headings = document.getElementsByClassName("vert");
        for (var iter = 0; iter < headings.length; iter++) {
            var h = headings[iter];
            var label = h.innerText.trim();
            h.innerHTML = "";
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = h.style.font;
            context.textAlign = "right";
            context.save();
            var metrics = context.measureText(label);
            canvas.height = parseInt(metrics.width, 10);
            canvas.width = context.measureText("M").width; //най-точно приближение
            context.restore();
            context.font = h.style.font;
            //context.fillStyle = "#ff0000"; // red
            context.textAlign = "right";

            // hold top-right hand corner when rotating
            context.translate(canvas.width - 1, 0);
            //context.translate(0, 0);

            context.rotate((3 * Math.PI) / 2);

            context.fillText(label, 0, 0);
            h.appendChild(canvas);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.RotateColumns(document);
    }

    PrintElem() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        if (this.state.Landscape)
            mywindow.document.write(
                "<style>@media print {@page {size: A4 landscape; margin: 0px;} body { padding: 50px; } }"
            );
        else mywindow.document.write("<style>@media print {@page {margin: 0;} body { padding: 50px; } }");
        mywindow.document.write(`.tablethinborders {  border-collapse: collapse;}
        .tablethinborders th, .tablethinborders td {  border: 1px solid black;}</style>`);
        mywindow.document.write("</head><body >");
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(this.state.PackingListHtml);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        this.RotateColumns(mywindow.document);
        mywindow.print();
        //mywindow.close();

        return true;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        if (this.state.ShowPackingListData)
            return (
                <PackinglistData
                    plid={this.state.DisplayedPackingList}
                    hidepagefunc={() =>
                        this.setState(
                            { ShowPackingListData: false },
                            this.ShowPackingList(this.state.DisplayedPackingList)
                        )
                    }
                ></PackinglistData>
            );

        return Context.HasRight("rsalesreport") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("sales")}</div>
                <div className="panel-body">
                    <div className="col-md-4">
                        <button
                            type="button"
                            className={
                                this.state.QueryType === "packinglists"
                                    ? "btn btn-warning fullwidth"
                                    : "btn btn-default fullwidth"
                            }
                            onClick={() => this.ShowPackingListQuery()}
                        >
                            {Translation.Trans("packinglists")}
                        </button>
                    </div>
                    <div className="col-md-4">
                        <button
                            type="button"
                            className={
                                this.state.QueryType === "clientsandarticles"
                                    ? "btn btn-warning fullwidth"
                                    : "btn btn-default fullwidth"
                            }
                            onClick={() => this.ShowClientsAndArticles()}
                        >
                            {Translation.Trans("byclientsandarticles")}
                        </button>
                    </div>
                    <div className="col-md-4">
                        <button
                            type="button"
                            className={
                                this.state.QueryType === "clientsorarticles"
                                    ? "btn btn-warning fullwidth"
                                    : "btn btn-default fullwidth"
                            }
                            onClick={() => this.ShowClientsOrArticles()}
                        >
                            {Translation.Trans("byclientsorarticles")}
                        </button>
                    </div>
                    <p>&nbsp;</p>
                    {this.state.QueryType === "packinglists" && !this.state.ShowResult ? (
                        <div className="col-md-12">
                            <div className="col-md-12">
                                <select
                                    id="ddlPartner"
                                    className="form-control"
                                    onChange={() => this.ChangePartner()}
                                >
                                    {this.state.Partners.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <p>&nbsp;</p>
                            <div className="col-md-12">
                                {this.state.PackingLists.packing_lists ? (
                                    <table className="table table-striped">
                                        <tbody>
                                            {this.state.PackingLists.packing_lists.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.date}</td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-default"
                                                            onClick={() => this.ShowPackingList(item.id)}
                                                        >
                                                            {Translation.Trans("show")}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-default"
                                                            onClick={() => this.ShowCodes(item.id)}
                                                        >
                                                            {Translation.Trans("codes")}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {this.PackingListsPage > 0 ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={() => this.PackingListPageChange(-1)}
                                    >
                                        &lt;&lt;
                                    </button>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {(this.PackingListsPage + 1) * this.PageSize <
                                this.state.PackingLists.count ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={() => this.PackingListPageChange(1)}
                                    >
                                        &gt;&gt;
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                    {this.state.QueryType === "queryresult" ? (
                        <div className="col-md-12">
                            <div className="col-md-12">
                                {this.state.PackingListQueryResult.packing_lists ? (
                                    <table className="table table-striped">
                                        <tbody>
                                            {this.state.PackingListQueryResult.packing_lists.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.date}</td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-default"
                                                            onClick={() => this.ShowPackingList(item.id)}
                                                        >
                                                            {Translation.Trans("show")}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {this.state.PackingListQueryPage > 0 ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={
                                            this.state.AndOrOr === "and"
                                                ? () => this.ShowAndQueryResult(-1, false)
                                                : () => this.ShowOrQueryResult(-1, false)
                                        }
                                    >
                                        &lt;&lt;
                                    </button>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {(this.state.PackingListQueryPage + 1) * this.PageSize <
                                this.state.PackingListQueryResult.count ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={
                                            this.state.AndOrOr === "and"
                                                ? () => this.ShowAndQueryResult(1, false)
                                                : () => this.ShowOrQueryResult(1, false)
                                        }
                                    >
                                        &gt;&gt;
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                    {this.state.QueryType === "clientsandarticles" && !this.state.ShowResult ? (
                        <div>
                            <div className="col-md-5">
                                <label htmlFor="dpStartDateAnd">{Translation.Trans("FromDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeStartDateAnd}
                                    value={this.state.StartDateAnd}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-5">
                                <label htmlFor="dpEndDateAnd">{Translation.Trans("ToDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeEndDateAnd}
                                    value={this.state.EndDateAnd}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-default fullwidth"
                                    onClick={() => this.ShowAndQueryResult(0, true)}
                                >
                                    {Translation.Trans("show")}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-default fullwidth"
                                    onClick={() => this.ShowAndQueryReport()}
                                >
                                    {Translation.Trans("report")}
                                </button>
                            </div>
                            <div className="col-md-6">
                                {this.state.AndData.partners ? (
                                    <div>
                                        <SelectAll cbid="cbPartner_"></SelectAll>
                                        {this.state.AndData.partners.map((item) => (
                                            <div key={item.id} className="checkbox">
                                                <input
                                                    id={"cbPartner_" + item.id}
                                                    type="checkbox"
                                                    permvalue={item.id}
                                                    key={"andpartner" + item.id}
                                                />
                                                <label htmlFor={"cbPartner_" + item.id}>{item.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6">
                                {this.state.AndData.goods ? (
                                    <div>
                                        <SelectAll cbid="cbGood_"></SelectAll>
                                        {this.state.AndData.goods.map((item) => (
                                            <div key={item.id} className="checkbox">
                                                <input
                                                    id={"cbGood_" + item.id}
                                                    type="checkbox"
                                                    permvalue={item.id}
                                                    key={"andgood" + item.id}
                                                />
                                                <label htmlFor={"cbGood_" + item.id}>{item.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    ) : null}
                    {this.state.QueryType === "clientsorarticles" && !this.state.ShowResult ? (
                        <div>
                            <div className="col-md-5">
                                <label htmlFor="dpStartDateAnd">{Translation.Trans("FromDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeStartDateOr}
                                    value={this.state.StartDateOr}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-5">
                                <label htmlFor="dpEndDateAnd">{Translation.Trans("ToDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeEndDateOr}
                                    value={this.state.EndDateOr}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-default fullwidth"
                                    onClick={() => this.ShowOrQueryResult(0, true)}
                                >
                                    {Translation.Trans("show")}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-default fullwidth"
                                    onClick={() => this.ShowOrQueryReport()}
                                >
                                    {Translation.Trans("report")}
                                </button>
                            </div>

                            <div className="col-md-6">
                                <div className="radio">
                                    <input
                                        id="rbIsPartner_1"
                                        type="radio"
                                        name="IsPartner"
                                        onChange={() => this.ChangeIsPartner(true)}
                                        defaultChecked={true}
                                    />
                                    <label htmlFor="rbIsPartner_1">{Translation.Trans("byclients")}</label>
                                </div>
                                <div className="radio">
                                    <input
                                        id="rbIsPartner_2"
                                        type="radio"
                                        name="IsPartner"
                                        onChange={() => this.ChangeIsPartner(false)}
                                    />
                                    <label htmlFor="rbIsPartner_2">{Translation.Trans("byarticles")}</label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                {this.state.IsPartner ? (
                                    this.state.OrData.partners ? (
                                        <div>
                                            <SelectAll cbid="cbPartner_"></SelectAll>
                                            {this.state.OrData.partners.map((item) => (
                                                <div key={item.id} className="checkbox">
                                                    <input
                                                        id={"cbPartner_" + item.id}
                                                        type="checkbox"
                                                        permvalue={item.id}
                                                        key={"orpartner" + item.id}
                                                    />
                                                    <label htmlFor={"cbPartner_" + item.id}>
                                                        {item.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    ) : null
                                ) : this.state.OrData.goods ? (
                                    <div>
                                        <SelectAll cbid="cbGood_"></SelectAll>
                                        {this.state.OrData.goods.map((item) => (
                                            <div key={"cbGood_" + item.id} className="checkbox">
                                                <input
                                                    id={"cbGood_" + item.id}
                                                    type="checkbox"
                                                    permvalue={item.id}
                                                    key={"orgood" + item.id}
                                                />
                                                <label htmlFor={"cbGood_" + item.id}>{item.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    ) : null}
                    {this.state.QueryType === "ShowPackingListData" ? (
                        <PackinglistData
                            ref="pddata"
                            plid={this.state.DisplayedPackingList}
                            hidepagefunc={this.ShowPackingListReport}
                        ></PackinglistData>
                    ) : null}

                    {this.state.QueryType === "ShowPackingList" ? (
                        <div className="row">
                            <div
                                className="col-md-12"
                                id="dPackingList"
                                dangerouslySetInnerHTML={{ __html: this.state.PackingListHtml }}
                            ></div>
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={this.PrintElem}>
                                    <i className="fa fa-print"></i>
                                    <p>{Translation.Trans("print")}</p>
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        var CUSTOMER = window.CONFIG
                                            && window.CONFIG.CUSTOMER;
                                            // : process.env.REACT_APP_CUSTOMER;
                                        if (
                                            CUSTOMER === "HUMANA" &&
                                            this.state.ExportType &&
                                            this.state.ExportType.type === "ShowAndQueryReport"
                                        ) {
                                            this.ShowAndQueryReport(true);
                                        } else if (
                                            CUSTOMER === "HUMANA" &&
                                            this.state.ExportType &&
                                            this.state.ExportType.type === "ShowOrQueryReport"
                                        ) {
                                            this.ShowOrQueryReport(true);
                                        } else {
                                            this.Export(this.state.PackingListHtml);
                                        }
                                    }}
                                    // replacing onClick => this.Export(this.state.PackingListHtml)
                                >
                                    <i className="fas fa-table"></i>
                                    <p>{Translation.Trans("export")}</p>
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => this.setState({ ShowPackingListData: true })}
                                >
                                    <i className="fas fa-edit" aria-hidden="true"></i>
                                    <p>{Translation.Trans("editdata")}</p>
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default SalesReport;



// WEBPACK FOOTER //
// ./src/pages/salesreport.js